import React, { Component } from 'react';
import './styles.css';

export default class OrdersTotalizers extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Countdown />
        {
          this.props.number !== null
            ? <OrdersFireworks number={ this.props.number.formatUnit('count', ' ') } animation={ this.props.animation } />
            : false
        }
        {
          this.props.loaded
          ?
            (<div className="flex-l items-center-l">
              <div className="flex-l flex-column-l w-60-l">
                <ActiveStores now={ this.props.data.now.sellingAccounts } pastYear={ this.props.data.lastYear.sellingAccounts } growth={ this.props.data.lastYear.sellingAccountsGrowth } show_last_year={ this.props.show_last_year }/>
                <TotalOrders count={ this.props.data.now.count.withSeparator('.') } last_update={ this.props.last_updated } />
              </div>
              <TotalOrdersCompared
                yesterday={ this.props.data.yesterday }
                past_week={ this.props.data.lastWeek }
                past_year={ this.props.data.lastYear }
                show_last_year={ this.props.show_last_year }
              />
            </div>)
          : ''
        }
      </div>
    );
  }
}
export class ActiveStores extends Component {
  render() {
    return (
      <div className="center ph1 mb3 w-60-m w-90-l mt4-m self-end-l order-1">
        <div className="flex items-center w-100 center ">
          <h3 className="mv0 f3 f2-l fw1 mr2 mr0-m tc-m tc-l w-50-m center-m">Selling Stores</h3>
          <div className="flex center w-100 w-80-m">
            <div className="flex-auto pv2 tc bg-dark-violet">
              <h4 className="mv0 fw3 f4-l">Today</h4>
              <p className="mv0 pt2 fw6 f4 f3-m f2-l">{ this.props.now }</p>
            </div>
            { 
            this.props.show_last_year ?
            (
            <div className="flex-auto pv2 ml2 ml2-m tc bg-dark-violet ml0-m">
              <h4 className="mv0 fw3 f4-l">Last year</h4>
              <p className="mv0 pt2 fw6 f4 f3-m f2-l">{ this.props.pastYear }</p>
            </div>
            ) : null
            }
            { 
            this.props.show_last_year ?
            (
            <div className="flex-auto pv2 ml2 ml2-m tc bg-dark-violet ml0-m">
              <h4 className="mv0 fw3 f4-l">Growth</h4>
              <p className="mv0 pt2 fw6 f4 f3-m f2-l">{ Math.round(this.props.growth) }%</p>
            </div>
            ) : null
            }
          </div>
        </div>
      </div>
    );
  }
}

export class TotalOrders extends Component {
  render() {
    return (
      <div className="w-80-ns w-60-m w-100-l flex-m flex-l justify-between-m align-end-m center order-0">
        <div className="orders-total w-80-ns center-ns">
          {/* If there's more than 5 characters in total orders numbers, you might want to reduce the value of the 'orders-total' property on index.css for some displays */ }
          <p className="f-headline mt0 mb1 pr3 fw9 tc tr-l">{ this.props.count }</p>
        </div>
        <div className="w-20-ns flex-l flex-column-l justify-center-l items-center-l tc tl-m tl-l p2-l self-end-m">
          <h1 className="f2 fw6 f2-l mv0 pb2-m lh-solid">Orders Today</h1>
          <h5 className="f6 f5-l fw1 mv0 mt3-l self-start-l">last update at { this.props.last_update }</h5>
        </div>
      </div>
    );
  }
}
export class TotalOrdersCompared extends Component {
  render() {
    return (
      <div className="center right-l w-100 w-80-ns w-60-m w-40-l mv4 mv0-l pl4-l mt0-l order-2">
        <div className={ "flex mv2 pv0-l items-center orders-comparator " + (this.props.yesterday.percent < 0 ? "bg-red" : "bg-green") }>
          <h2 className="w-30 mv0 f5 f4-ns f3-l fw4 pl2 pl4-l flex-auto">Yesterday</h2>
          <p className="w-50 mv0 f3 f2-ns f1-l fw8 tc flex-auto">{ this.props.yesterday.count.withSeparator('.') }</p>
          <p className={ "w-20 mv0 f6 f4-ns f3-l fw6 tc flex-auto pv3 pv4-l " + (this.props.yesterday.percent < 0 ? "bg-dark-red" : "bg-dark-green") }>{ this.props.yesterday.percent ? this.props.yesterday.percent + '%' : '---' }</p>
        </div>
        <div className={ "flex mv2 pv0-l items-center orders-comparator " + (this.props.past_week.percent < 0 ? "bg-red" : "bg-green") }>
          <h2 className="w-30 mv0 f5 f4-ns f3-l fw4 pl2 pl4-l flex-auto">Last week</h2>
          <p className="w-50 mv0 f3 f2-ns f1-l fw8 tc flex-auto">{ this.props.past_week.count.withSeparator('.') }</p>
          <p className={ "w-20 mv0 f6 f4-ns f3-l fw6 tc flex-auto pv3 pv4-l " + (this.props.past_week.percent < 0 ? "bg-dark-red" : "bg-dark-green") }>{ this.props.past_week.percent ? this.props.past_week.percent + '%' : '---' }</p>
        </div>
        {
          this.props.past_year.count && this.props.past_year.percent ?
          (
          <div className={ "flex mv2 pv0-l items-center orders-comparator " + (this.props.past_year.percent < 0 ? "bg-red" : "bg-green") }>
            <h2 className="w-30 mv0 f5 f4-ns f3-l fw4 pl2 pl4-l flex-auto">Last year</h2>
            <p className="w-50 mv0 f3 f2-ns f1-l fw8 tc flex-auto">{ this.props.past_year.count.withSeparator('.') }</p>
            <p className={ "w-20 mv0 f6 f4-ns f3-l fw6 tc flex-auto pv3 pv4-l " + (this.props.past_year.percent < 0 ? "bg-dark-red" : "bg-dark-green") }>{ this.props.past_year.percent ? this.props.past_year.percent + '%' : '---' }</p>
          </div>
          ) : <div></div>
        }
      </div>
    );
  }
}
class Countdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      startTime: new Date('2022-11-24T23:59:40'),
      number: 20,
      message: null
    };
    this.worker = setInterval(_ => this.shouldStart(), 1000);
  }
  shouldStart() {
    const { startTime } = this.state;
    let now = new Date();
    if (now > startTime) {
      clearInterval(this.worker);
      if (now < new Date(startTime).addMilliseconds(2000)) {
        this.setState({ show: true });
        this.start();
      }
    }
  }
  start() {
    this.worker = setInterval(() => {
      const stt = this.state;
      if (stt.number > 1) {
        stt.number = stt.number - 1;
      } else {
        clearInterval(this.worker);
        location.reload(true)
      }
      this.setState(stt);
    }, 1000);
  }
  render() {
    if (!this.state.show) return false;
    return (
      <div className="fl w-100 fake-page fixed z-30 aspect-ratio--object">
        <div className="fl w-100 z-max tc fw9 countdown">{ this.state.number }</div>
        <div className="fl w-100 z-max tc dtc fw6 message">{ this.state.message }</div>
      </div>
    );
  }
}

class OrdersFireworks extends Component {
  render() {
    const { animation, number } = this.props;
    if (!animation) return false;
    else if (animation === 'schirmer') {
      return (
        <div className="fl w-100 bg-black-70 fixed z-30 aspect-ratio--object">
          <Orders number={ number } />
          <Schirmer />
        </div>
      );
    }
    else if (animation === 'rod') {
      return (
        <div className="fl w-100 bg-black-70 fixed z-30 aspect-ratio--object">
          <Orders number={ number } />
          <Rod />
        </div>
      );
    }
    else if (animation === 'bcap') {
      return (
        <div className="fl w-100 bg-black-70 fixed z-30 aspect-ratio--object">
          <Orders number={ number } />
          <Bcap />
        </div>
      );
    }
    return (
      <div className="fl w-100 fireworks bg-black-90 fixed z-30 aspect-ratio--object">
        <OrderNumber number={ number } />
      </div>
    );
  }
}
class Orders extends Component {
  render() {
    return (
      <div className="fl w-100 z-max tc pa5 fw8 total-orders-fireworks">
        <span className="order-number">
          { this.props.number }
        </span>
        <br />
        orders
      </div>
    );
  }
}
class OrderNumber extends Component {
  render() {
    return (
      <div className="fl w-100 z-max tc fw9 total-orders">
        <span className="order-number">
          { this.props.number }
        </span>
        <br />
        orders
      </div>
    );
  }
}
class Schirmer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    setTimeout(() => {
      this.setState({
        show: true,
      });
    }, 5000);
  }
  render() {
    if (!this.state.show) return false;
    return (
      <div className="fl w-100 z-max">
        <audio src="/toasty.mp3" autoPlay={ true } />
        <img className="toasted tc items-center tl absolute" src="/schirmer.png" />
      </div>
    );
  }
}
class Bcap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    setTimeout(() => {
      this.setState({
        show: true,
      });
    }, 5000);
  }
  render() {
    if (!this.state.show) return false;
    return (
      <div className="fl w-100 z-max">
        <audio src="/toasty.mp3" autoPlay={ true } />
        <img className="toasted tc items-center tl absolute" src="/bcap.png" />
      </div>
    );
  }
}
class Rod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    setTimeout(() => {
      this.setState({
        show: true,
      });
    }, 5000);
  }
  render() {
    if (!this.state.show) return false;
    return (
      <div className="fl w-100 z-max">
        <audio src="/toasty.mp3" autoPlay={ true } />
        <img className="toasted tc items-center tl absolute" src="/rod.png" />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Orders/OrdersTotalizers/index.js